import { DataInput, DataInputType } from '@/types/automationFields.ts';
import { AutomationStep } from '@/types/automationSteps.ts';
import DataInputSelectorUI from '@/pages/Editor/components/SharedFields/DataInputSelector/DataInputSelectorUI.tsx';

type props = {
  step: AutomationStep;
  label?: string;
  dataInputError?: string;
  dataInput: DataInput;
  onChange: (dataInput: DataInput) => void;
  includeEmptyDatasets?: boolean;
  allowedDataInputTypes?: DataInputType[];
  scopeOverride?: 'root' | 'local_subflow';
};

const SingleDataInputSelectorInner = ({
  step,
  label,
  dataInputError,
  dataInput,
  onChange,
  includeEmptyDatasets,
  allowedDataInputTypes,
  scopeOverride,
}: props) => {
  return (
    <DataInputSelectorUI
      dataInput={dataInput}
      stepId={step.step_id}
      updateDataInput={onChange}
      error={dataInputError}
      includeEmptyDatasets={includeEmptyDatasets}
      allowedDataInputTypes={allowedDataInputTypes}
      label={label}
      scopeOverride={scopeOverride}
    />
  );
};

export default SingleDataInputSelectorInner;
